// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SmartTextareaInput":"bfz_a bhl_ve bhl_vr bhl_xh bhl_vj"};